import Axios from "../api/axios";
import config from "../../config";

const getGrappleLetters = () => {
  return Axios.get(`${config.BASE_URL}grapple-letter`);
};

export default getGrappleLetters;
